<template>
  <el-dialog
    :visible.sync="visible"
    :title="`AI Analysis - ${track && track.title ? track.title : ''}`"
    width="600px"
    custom-class="premium-modal ai-modal"
    @close="$emit('close')"
  >
    <div v-if="track && track.ai" class="ai-analysis-content">
      <div class="ai-confidence-meter">
        <div class="meter-label">AI Detection Confidence</div>
        <div class="meter-container">
          <div class="meter-fill" :style="{ width: track.ai.confidence + '%' }">
            <span class="meter-value">{{ track.ai.confidence }}%</span>
          </div>
        </div>
        <div class="meter-scale">
          <span>0%</span>
          <span>25%</span>
          <span>50%</span>
          <span>75%</span>
          <span>100%</span>
        </div>
      </div>

      <div class="ai-status" :class="track.ai.is_ai_generated ? 'ai-detected' : 'human-created'">
        <i :class="track.ai.is_ai_generated ? 'el-icon-warning' : 'el-icon-success'"></i>
        <span>{{ track.ai.is_ai_generated ? 'AI Generated Content Detected' : 'Likely Human Created' }}</span>
      </div>

      <div class="analysis-details">
        <h4>Analysis Details</h4>
        <p>{{ track.ai.analysis }}</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AIAnalysisModal',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    track: {
      type: Object,
      default: null
    }
  },

  watch: {
    visible(val) {
      if (!val) {
        this.$emit('update:visible', false)
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Premium Modal Styles
.premium-modal {
  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #e55279 0%, #9b6dbb 100%);
    padding: 20px;

    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: white;
      font-size: 20px;

      &:hover {
        color: #f0f0f0;
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 30px;
  }
}

// AI Modal Specific Styles
.ai-modal {
  ::v-deep .ai-analysis-content {
    .ai-confidence-meter {
      margin-bottom: 30px;

      .meter-label {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 600;
      }

      .meter-container {
        height: 40px;
        background: #f0f2f5;
        border-radius: 20px;
        overflow: hidden;
        position: relative;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);

        .meter-fill {
          height: 100%;
          background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 15px;
          transition: width 0.5s ease;

          .meter-value {
            color: white;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }

      .meter-scale {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        font-size: 11px;
        color: #999;
      }
    }

    .ai-status {
      padding: 20px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 25px;

      i {
        font-size: 24px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
      }

      &.ai-detected {
        background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
        border: 2px solid #ff6b6b;
        color: #c92a2a;
      }

      &.human-created {
        background: linear-gradient(135deg, #f0fff4 0%, #d3f9d8 100%);
        border: 2px solid #51cf66;
        color: #2b8a3e;
      }
    }

    .analysis-details {
      background: #f8f9fa;
      padding: 20px;
      border-radius: 12px;

      h4 {
        margin: 0 0 15px 0;
        color: #495057;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      p {
        margin: 0;
        color: #666;
        line-height: 1.8;
        font-size: 14px;
      }
    }
  }
}
</style>